export const mapResponse = (response, requestCache) => {
  if (response.config.method === "get") {
    if (requestCache.has(response.config)) {
      requestCache.delete(response.config); // Delete request controller from cache after it was finished
    }
  }
  return response.data;
};
